// extracted by mini-css-extract-plugin
export var scrollArea = "_p7-0";